export const REGION = "asia-southeast1";
// local
export const LOCAL_USER = "Local User";
// ref
export const REF = {
  OPERATOR: "operator",
  CONCEPT: "concept",
  CONCEPT_REPORT: "conceptReport",
  USER: "user",
  CLIENT: "client",
  ORDER: "order",
  //concept
  CONCEPT_TICKET: "conceptTicket",
  CONCEPT_FOMULAR: "conceptFomular",
  CONCEPT_MAP: "conceptMap",
  CONCEPT_CONTENT: "conceptContent",
  CONCEPT_MINIMAP: "conceptMinimap",
  CONCEPT_SPORT: "conceptSport",
  CONCEPT_SPORT_APPROVAL: "conceptSportApproval",

  //three js
  THREE_MAPPER: "threeMapper",
  THREE_BRAND_MAP: "threeBrandMap",
  //certificate
  CERTIFICATE: "certificate",
  CERTIFICATE_ZONE: "certificateZone",

  //
  STRAVA: "strava",
};

export const API = {
  FITNESS_ACTIVITY: "api-fitness-activity-get",
  TOP_BOARD_FITNESS: "api-top-boards-fitness",

  THREE_MAPPER_JSON: "api-three-mapper-json",
  //ticket
  CONCEPT_TICKET_ACTIVATE: "api-concept-ticket-activate", //{concept, email}
  CONCEPT_REMAP_VERSION: "api-concept-remap-version", //{concept}

  //fitness ticket
  FITNESS_TICKET_ACTIVATE: "api-fitness-ticket-activate", // {email, virtual}
  FITNESS_CODE_TICKET: "api-fitness-code-ticket", // {code, virtual}
};

export const STORAGE_KEY = [
  {
    storage: "media",
    collection: "fitnessVirtual",
  },
  {
    storage: "route",
    collection: "fitnessVirtualRoute",
  },
  {
    storage: "treasure",
    collection: "fitnessVirtualTreasure",
  },
  {
    storage: "charity",
    collection: "fitnessVirtualCharity",
  },
];
